import styled from "@emotion/styled";
import { Button, Card, Col, Row, Tabs, Typography } from "antd";
import { goBack, chat, search } from "assets/icons/index";
import { useNavigate } from "react-router-dom";
import {
  useGetLoadNewOrders,
} from "hooks/useOrders";
import { useAppSelector, useAppDispatch, store } from 'store'

import { reset, setReload, setTabSelected } from 'store/slices/orderSlice'
import OrderTabsCard from "./OrderTabsCard";
import { useEffect, useState } from "react";
import OrderPrepareShip from "./OrderPrepareShip";
import OrderShipped from "./OrderShipped";
import OrderCompleted from "./OrderCompleted";
import OrderCancel from "./OrderCancel";
import OrderCredit from "./OrderCredit";
import OrderCodCreditCard from "./shared/OrderCodCreditCard";

interface OrderCardProps {
  order_id: string;
}

const OrderCard = ({ order_id }: OrderCardProps) => {
  const navigate = useNavigate();

  const tabSelected = useAppSelector((state) => state.order.tabSelected);

  const dispatch = useAppDispatch();

  const reload = useAppSelector((state) => state.order.reload);
  const userProfile = useAppSelector((state) => state.auth.profile);
  const userContactData = useAppSelector((state) => state.auth.contact);

  const [searchInput, setSearchInput] = useState<string>('');
  const [dateInput, setDateInput] = useState<string>('');
  const [roleType, setRoleType] = useState<string>('');

  const pagging = useAppSelector((state) => state.order);
  const [isInitialized, setIsInitialized] = useState(false);
  useEffect(() => {
    if (!isInitialized) {
      dispatch(reset());
      setIsInitialized(true);
    }
  }, [dispatch, isInitialized]);

  useEffect(() => {
    if (reload) {
      dispatch(setReload(false));
    }
  }, [reload, dispatch]);

  const { data: dataNewOrders, isLoading: newOrdersIsLoading, refetch: refectNewOrders } = useGetLoadNewOrders({
    status: "new_order",
    search: searchInput,
    order_date: dateInput,
    offset: pagging.dataNewOrders.offset,
    limit: pagging.dataNewOrders.limit,
    factory_id: userContactData?.id
  })

  const { data: dataPrepareShip, isLoading: prepareShipIsLoading, refetch: refectPrepareShip } = useGetLoadNewOrders({
    status: "factory_approve",
    search: searchInput,
    order_date: dateInput,
    offset: pagging.dataPrepareShip.offset,
    limit: pagging.dataPrepareShip.limit,
    factory_id: userContactData?.id
  })

  const { data: dataShipped, isLoading: shippedLoading, refetch: refectShipped } = useGetLoadNewOrders({
    status: "wait_agent_confirm",
    search: searchInput,
    order_date: dateInput,
    offset: pagging.dataShipped.offset,
    limit: pagging.dataShipped.limit,
    factory_id: userContactData?.id
  })

  const { data: dataCredit, isLoading: creditLoading, refetch: refectCredit } = useGetLoadNewOrders({
    status: "credit_payment",
    search: searchInput,
    order_date: dateInput,
    offset: pagging.dataCredit.offset,
    limit: pagging.dataCredit.limit,
    factory_id: userContactData?.id
  })


  const { data: dataComplete, isLoading: completeLoading, refetch: refectchComplete } = useGetLoadNewOrders({
    status: "complete",
    search: searchInput,
    order_date: dateInput,
    offset: pagging.dataComplete.offset,
    limit: pagging.dataComplete.limit,
    factory_id: userContactData?.id
  })

  const { data: dataCancel, isLoading: cancelLoading, refetch: refectchCancel } = useGetLoadNewOrders({
    status: "cancel",
    search: searchInput,
    order_date: dateInput,
    offset: pagging.dataCancel.offset,
    limit: pagging.dataCancel.limit,
    factory_id: userContactData?.id,
    // แท็บยกเลิก: เรียงตามวันที่อัปเดตล่าสุดก่อน (backend map update_date -> order_update_date)
    sort_by: "update_date",
    sort_direction: "desc"
  })

  const items = [
    {
      label: `รับคำสั่งซื้อ (${dataNewOrders?.data.total_record ?? 0})`,
      key: "0",
      children:
        <OrderTabsCard
          data={dataNewOrders?.data}
          isLoading={newOrdersIsLoading}
          refetch={refectNewOrders}
          setSearchInput={setSearchInput}
          searchInput={searchInput}
          setDateInput={setDateInput}
          dateInput={dateInput}
          refetchPrepare={refectPrepareShip}
          refetchCancel={refectchCancel}
          refetchCredit={refectCredit}
        />
      ,
    },
    {
      label: `เตรียมจัดส่ง (${dataPrepareShip?.data.total_record ?? 0})`,
      key: "1",
      children:
        <>
          <OrderPrepareShip
            data={dataPrepareShip?.data}
            isLoading={prepareShipIsLoading}
            refetch={refectPrepareShip}
            setSearchInput={setSearchInput}
            searchInput={searchInput}
            setDateInput={setDateInput}
            dateInput={dateInput}
            refectShipped={refectShipped}
            refetchCancel={refectchCancel}
            refetchCredit={refectCredit}
          />
        </>

      ,
    },
    {
      label: `ระหว่างจัดส่ง (${dataShipped?.data.total_record ?? 0})`,
      key: "2",
      children:
        <>
          <OrderShipped
            data={dataShipped?.data}
            isLoading={shippedLoading}
            refetch={refectShipped}
            setSearchInput={setSearchInput}
            searchInput={searchInput}
            setDateInput={setDateInput}
            dateInput={dateInput}
            refetchTo={refectPrepareShip}
            refetchCredit={refectCredit}
          />
        </>
      ,
    },
    {
      label: `รอชำระ/COD (${dataCredit?.data.total_record ?? 0})`,
      key: "4",
      children:
        <>
          <OrderCredit
            data={dataCredit?.data}
            isLoading={creditLoading}
            refetch={refectCredit}
            setSearchInput={setSearchInput}
            searchInput={searchInput}
            setDateInput={setDateInput}
            dateInput={dateInput}
            refetchTo={refectchComplete}
          />
        </>
      ,
    },
    {
      label: `เสร็จสิ้น `,
      key: "6",
      children:
        <>
          <OrderCompleted
            data={dataComplete?.data}
            isLoading={completeLoading}
            refetch={refectchComplete}
            setSearchInput={setSearchInput}
            searchInput={searchInput}
            setDateInput={setDateInput}
            dateInput={dateInput}
          />
        </>
      ,
    },
    {
      label: `ยกเลิก (${dataCancel?.data.total_record ?? 0})`,
      key: "8",
      children:
        <>
          <OrderCancel
            data={dataCancel?.data}
            isLoading={cancelLoading}
            refetch={refectchCancel}
            setSearchInput={setSearchInput}
            searchInput={searchInput}
            setDateInput={setDateInput}
            dateInput={dateInput}
          />
        </>
      ,
    },
  ];

  useEffect(() => {
    if (userProfile) {
      setRoleType(userProfile.user.role.ref_type);
    }
  }, [userProfile]);

  return (
    <>
      <Card bordered={false} className="criclebox h-full tabs-mobile">
        <Row className="rowgap-vbox" gutter={[24, 0]}>
          <Col sm={24} md={24}>
            <Tabs
              activeKey={tabSelected}
              style={{ height: "100%" }}
              items={items}
              onChange={(key) => {
                dispatch(setTabSelected(key));
              }}
              renderTabBar={(props, DefaultTabBar) => (
                <TopSplit>
                  <LeftPane>
                    <HeaderTabs>
                      {roleType !== 'admin' ? (
                        <IconWrapper
                          onClick={() => {
                            navigate("/dashboard");
                          }}
                        >
                          <SpanIcon>{goBack}</SpanIcon>
                        </IconWrapper>
                      ) : (
                        <IconWrapper>
                        </IconWrapper>
                      )}
                      {/* หัวข้ออยู่กลางของโซนซ้ายเอง (บาลานซ์ด้วย spacer กว้างเท่าปุ่มกลับ) */}
                      <Typography.Title
                        level={5}
                        style={{ margin: 0, flex: 1, textAlign: "center" }}
                      >
                        คำสั่งซื้อ
                      </Typography.Title>
                      <HeaderBalanceSpacer />
                    </HeaderTabs>
                    <DefaultTabBar {...props} />
                  </LeftPane>
                  <RightPane>
                    <OrderCodCreditCard />
                  </RightPane>
                </TopSplit>
              )}
            />
          </Col>
        </Row>
      </Card>
    </>
  );
};

export default OrderCard;

/** ซ้าย = หัวข้อ+แท็บ (ยืดเต็มที่เหลือ) / ขวา = เครดิตกว้างตามเนื้อหา (max-content) */
const TopSplit = styled.div`
  display: flex;
  flex-direction: row;
  align-items: flex-start;
  gap: 12px;
  margin-bottom: 8px;
`;

const LeftPane = styled.div`
  flex: 1 1 auto;
  min-width: 0;

  .ant-tabs-nav {
    margin-top: 12px;
    margin-bottom: 0;
    padding-left: 16px;
  }
`;

const RightPane = styled.div`
  flex: 0 0 auto;
  width: max-content;
  padding: 8px 10px 0 0;
`;

const HeaderTabs = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 8px 10px 8px 10px;
  flex-direction: row;
`;

/** กว้าง×สูงเท่า IconWrapper ซ้าย — บาลานซ์ให้หัวข้อ "คำสั่งซื้อ" อยู่กลางโซนซ้าย */
const HeaderBalanceSpacer = styled.div`
  width: 40px;
  height: 30px;
  flex-shrink: 0;
  visibility: hidden;
  pointer-events: none;
`;

/** เดิมเคยห่อการ์ดเครดิตมุมขวาหัวหน้า / เต็มความกว้างเหนือแท็บ — ย้ายไป RightPane แล้ว */
// const RightIconWrapper = styled.div`
//   display: flex;
//   flex-direction: row;
//   align-items: center;
//   padding: 4px 4px 4px 0;
// `;
// const OrderCreditTop = styled.div`
//   padding: 0 10px 0 10px;
// `;
// const OrderTabsWrap = styled.div`
//   .ant-tabs-nav {
//     margin-top: 0;
//     margin-bottom: 8px;
//   }
// `;

const IconWrapper = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  width: 40px;
  height: 30px;
  border-radius: 6px;
  background-color: #ffffff;
  cursor: pointer;
  transition: all 0.3s ease-in-out;
  &:hover {
    background-color: #efefef;
  }
`;

const SpanIcon = styled.span`
  display: flex;
  align-items: center;
  justify-content: center;
  width: 100%;
  height: 100%;
`;
